import { RED_FLAGS, SECTIONS } from './tech-due-diligence-quiz.data';
import { Answers, Flags, Level, Results, SectionScore, Verdict } from './tech-due-diligence-quiz.types';

const LEVEL_SCORES: Record<Level, number> = { L4: 4, L3: 3, L2: 2, L1: 1 };

function countCheckedFlags(flags: Flags, categoryId: string): number {
  const category = RED_FLAGS.categories.find((c) => c.id === categoryId);
  return category ? category.items.filter((_, i) => flags[`${categoryId}:${i}`]).length : 0;
}

export function computeResults(answers: Answers, flags: Flags): Results {
  const sectionScores: SectionScore[] = SECTIONS.map((section) => {
    const scores = section.questions.map((_, qIndex) => {
      const level = answers[`${section.id}:${qIndex}`];
      return level ? LEVEL_SCORES[level] : null;
    });
    const answered = scores.filter((score): score is number => score !== null);
    const avg = answered.length ? answered.reduce((a, b) => a + b, 0) / answered.length : null;
    return { section, avg };
  });

  const allAnswered = sectionScores.every((s) => s.avg !== null);
  const overall = allAnswered ? sectionScores.reduce((sum, s) => sum + (s.avg as number) * s.section.weight, 0) : null;

  const instantKillCount = countCheckedFlags(flags, 'instantKill');
  const majorMitigationCount = countCheckedFlags(flags, 'majorMitigation');
  const watchItemCount = countCheckedFlags(flags, 'watchItem');

  let verdict: Verdict = 'proceed';
  if (instantKillCount > 0) verdict = 'stop';
  else if (majorMitigationCount >= 3) verdict = 'renegotiate';

  return { sectionScores, overall, allAnswered, instantKillCount, majorMitigationCount, watchItemCount, verdict };
}
